import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import "./PurchaseInTotalForm.scss";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { useHistory, useParams } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import SuppliersModal from "../SuppliersCRUD/SuppliersModal";
import { getUnitID } from "../../Auth/GetUnitCompany";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import CircularProgress from "@mui/material/CircularProgress";
import { useVatDeclarant } from "../../GetData/Context/CompanyDataContext";
import AccountsAutocompleteEdit from "../../Components/AccountsAutocompleteEdit";
import AccountsAutocompleteInsert from "../../Components/AccountsAutocompleteInsert";
import PriceField from "../../Components/NumberFieldFormater";
import PaymentTypeSelect from "../../Components/PaymentTypeSelect";

const formatEuroValue = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const round2 = (value) => {
  const parsed = Number(value || 0);
  if (!Number.isFinite(parsed)) {
    return 0;
  }
  return Math.round((parsed + Number.EPSILON) * 100) / 100;
};

const createEmptySnapshot = () => ({
  invoiceNR: "",
  date: "",
  payDate: "",
  supplierID: "",
  paymentOptions: "",
  transactionType: 1,
  coment: "",
  amount0: 0,
  amount8: 0,
  amount18: 0,
  vat8: 0,
  vat18: 0,
  valueWithVAT0: 0,
  valueWithVAT8: 0,
  valueWithVAT18: 0,
});

function PurchaseInTotalForm(props) {
  const history = useHistory();
  const { transactionId } = useParams();
  const isEditMode = Boolean(transactionId);

  const TranscationData = [
    {
      id: 1,
      type: "Vendore",
    },
    {
      id: 2,
      type: "Import",
    },
    {
      id: 4,
      type: "Ngarkesa e Kundert",
    },
  ];

  const headers = useMemo(() => authHeader(), []);
  const email = LoginUserDetailed();
  const { fiscalYear } = useContext(FiscalYearContext);
  const isVatDeclarant = useVatDeclarant();
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDare] = useState("");

  useEffect(() => {
    setMinDate(`${fiscalYear}-01-01`);
    setMaxDare(`${fiscalYear}-12-31`);
  }, [fiscalYear]);

  const [date, setDate] = useState("");
  const [payDate, setPayDate] = useState("");
  const [invoiceNR, setInvoiceNR] = useState("");
  const [supplierID, setSupplierID] = useState("");
  const [amount0, setAmount0] = useState(0);
  const [amount8, setAmount8] = useState(0);
  const [amount18, setAmount18] = useState(0);
  const [vat8, setVat8] = useState(0);
  const [vat18, setVat18] = useState(0);
  const [coment, setComent] = useState("");
  const [paymentOptions, setPaymentOptions] = useState("");
  const [transactionType, setTransactionType] = useState(1);
  const [unId, setUnID] = useState("");

  const [insertingTransaction, setInsertingTransaction] = useState(false);
  const [isInitializing, setIsInitializing] = useState(isEditMode);
  const [editingTransactionId, setEditingTransactionId] = useState("");
  const [initialInvoiceNr, setInitialInvoiceNr] = useState("");
  const [showSupplierModal, setShowSupplierModal] = useState(false);
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);
  const [initialFormSnapshot, setInitialFormSnapshot] = useState(
    createEmptySnapshot(),
  );
  const invoiceNrInputRef = useRef(null);

  const paymentMenuProps = {
    PaperProps: {
      sx: {
        maxHeight: 280,
        maxWidth: "min(460px, calc(100vw - 32px))",
        mt: 0.5,
        overflowY: "auto",
        borderRadius: "10px",
        "& .MuiMenuItem-root": {
          fontSize: "13px",
          minHeight: 36,
          whiteSpace: "normal",
          wordBreak: "break-word",
        },
      },
    },
  };

  const sharedDropdownIcon = (props) => (
    <svg
      {...props}
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#4E7B67"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );

  const [validationErrors, setValidationErrors] = useState({
    invoiceNR: "",
    date: "",
    payDate: "",
    supplierID: "",
    paymentOptions: "",
  });

  const focusInvoiceField = () => {
    window.setTimeout(() => {
      if (invoiceNrInputRef.current) {
        invoiceNrInputRef.current.focus();
        invoiceNrInputRef.current.select?.();
      }
    }, 0);
  };

  const [cashRegister, setCashRegister] = useState([]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setInsertingTransaction(true);

    const nextErrors = {
      invoiceNR: "",
      date: "",
      payDate: "",
      supplierID: "",
      paymentOptions: "",
    };

    if (!invoiceNR) {
      nextErrors.invoiceNR = "Numri i faturës është i detyrueshëm.";
    }
    if (!date) {
      nextErrors.date = "Data e faturës është e detyrueshme.";
    }
    if (!payDate) {
      nextErrors.payDate = "Data e pagesës është e detyrueshme.";
    }
    if (!supplierID) {
      nextErrors.supplierID = "Ju lutem zgjidhni furnitorin.";
    }
    if (!paymentOptions) {
      nextErrors.paymentOptions = "Ju lutem zgjidhni mënyrën e pagesës.";
    }

    if (Object.values(nextErrors).some(Boolean)) {
      setValidationErrors(nextErrors);
      setInsertingTransaction(false);
      if (!isEditMode) {
        focusInvoiceField();
      }
      return;
    }

    setValidationErrors({
      invoiceNR: "",
      date: "",
      payDate: "",
      supplierID: "",
      paymentOptions: "",
    });

    const stateDate = {
      Date: date,
      PayDate: payDate,
      ActionType: "POT",
      InvoiceNr: invoiceNR,
      SupplierID: supplierID,
      Amount0: amount0,
      Amount8: amount8,
      Amount18: amount18,
      PaymentOptions: paymentOptions,
      TransactionType: transactionType,
      CompanyUnitID: unId > 0 ? unId : null,
      Coment: coment,
      ...(isEditMode
        ? {
            TransactionID: Number(editingTransactionId || transactionId),
            ModifiedByUser: email,
          }
        : {
            CreatedByUser: email,
          }),
    };
    const request = isEditMode
      ? axios.put(
          ApiLink.API_URL + "PurchaseInTotal/update-purchase-in-total",
          {
            ...stateDate,
            AccountID: Number(supplierID),
            PaymentOptions: Number(paymentOptions || 0),
            TransactionType: Number(transactionType || 1),
          },
          { headers },
        )
      : axios.post(
          ApiLink.API_URL + "PurchaseInTotal/insert-purchase-in-total",
          stateDate,
          { headers },
        );

    request
      .then(() => {
        handleSuccess(
          isEditMode
            ? "Blerja në total u përditësua me sukses"
            : "Blerja në total u shtua me sukses",
        );

        if (isEditMode) {
          closePage();
          return;
        }

        setDate("");
        setPayDate("");
        setInvoiceNR("");
        setSupplierID("");
        setComent("");
        setPaymentOptions("");
        setAmount0(0);
        setAmount8(0);
        setAmount18(0);
        setTransactionType(1);
        // setSupplierName("");
        setValueWithVAT0(0);
        setValueWithVAT8(0);
        setValueWithVAT18(0);
        setVat8(0);
        setVat18(0);
        setField(null);
        setValidationErrors({
          invoiceNR: "",
          date: "",
          payDate: "",
          supplierID: "",
          paymentOptions: "",
        });
        setInitialFormSnapshot(createEmptySnapshot());
        setInsertingTransaction(false);
        focusInvoiceField();
      })
      .catch((error) => {
        setInsertingTransaction(false);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
          setInsertingTransaction(false);
        } else {
          errorAlert(
            isEditMode
              ? "Ndodhi gabim gjatë përditësimit të blerjes në total."
              : "Ndodhi një gabim i panjohur gjatë përpunimit të kërkesës.",
          );
          setInsertingTransaction(false);
        }
      });
  };

  //   const fetchSuppliers = async () => {
  //     try {
  //       const response = await axios.get(
  //         ApiLink.API_URL + "Accounts/accountByLedger",
  //         { headers, params: { ledger: 302 } },
  //       );
  //       setSuppliers(response.data);
  //     } catch (error) {
  //       errorAlert("Gabim në kërkesë:", error);
  //       if (
  //         error.response &&
  //         error.response.data &&
  //         error.response.data.errorMessage
  //       ) {
  //         errorAlert(
  //           `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
  //         );
  //       } else if (error.message) {
  //         errorAlert(`Gabim: ${error.message} `);
  //       } else {
  //         errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //       }
  //     }
  //   };

  const fetchPaymentType = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/paymenttype",
        { headers },
      );
      setCashRegister(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  // ky kod sherben per ta kontrolluar nese nje numer i fatures ekzison, dhe e vendos butoni se qfar pamje do te merr
  const [invNumberExist, setInvNumberExist] = useState();
  const [invoiceOtherSupplierMessage, setInvoiceOtherSupplierMessage] = useState("");

  const [valueWithVAT0, setValueWithVAT0] = useState(0);
  const [valueWithVAT8, setValueWithVAT8] = useState(0);
  const [valueWithVAT18, setValueWithVAT18] = useState(0);

  const currentFormSnapshot = useMemo(
    () => ({
      invoiceNR: invoiceNR || "",
      date: date || "",
      payDate: payDate || "",
      supplierID: String(supplierID || ""),
      paymentOptions: String(paymentOptions || ""),
      transactionType: Number(transactionType || 1),
      coment: coment || "",
      amount0: round2(amount0),
      amount8: round2(amount8),
      amount18: round2(amount18),
      vat8: round2(vat8),
      vat18: round2(vat18),
      valueWithVAT0: round2(valueWithVAT0),
      valueWithVAT8: round2(valueWithVAT8),
      valueWithVAT18: round2(valueWithVAT18),
    }),
    [
      invoiceNR,
      date,
      payDate,
      supplierID,
      paymentOptions,
      transactionType,
      coment,
      amount0,
      amount8,
      amount18,
      vat8,
      vat18,
      valueWithVAT0,
      valueWithVAT8,
      valueWithVAT18,
    ],
  );

  const isFormDirty = useMemo(
    () =>
      JSON.stringify(currentFormSnapshot) !==
      JSON.stringify(initialFormSnapshot),
    [currentFormSnapshot, initialFormSnapshot],
  );

  const isInsertFormEmpty = useMemo(() => {
    if (isEditMode) return false;
    return (
      !invoiceNR &&
      !date &&
      !payDate &&
      !supplierID &&
      !paymentOptions &&
      !coment &&
      amount0 === 0 &&
      amount8 === 0 &&
      amount18 === 0
    );
  }, [
    isEditMode,
    invoiceNR,
    date,
    payDate,
    supplierID,
    paymentOptions,
    coment,
    amount0,
    amount8,
    amount18,
  ]);

  const closePage = () => {
    history.push("/purchases/purchaseintotal");
  };

  const handleCloseClick = () => {
    if (isFormDirty) {
      setShowCloseConfirm(true);
      return;
    }
    closePage();
  };

  const calculateWithoutVAT = async (withVAT, vat) => {
    try {
      const input = Number(withVAT);
      const noVAT = (input * 100) / (100 + Number(vat));
      const vatTotal = input - noVAT;

      if (vat == 0) {
        setAmount0(noVAT);
        setValueWithVAT0(input);
      } else if (vat == 8) {
        setAmount8(noVAT);
        setVat8(vatTotal);
        setValueWithVAT8(input);
      } else if (vat == 18) {
        setAmount18(noVAT);
        setVat18(vatTotal);
        setValueWithVAT18(input);
      }
    } catch (error) {
      console.error("Gabim gjatë kalkulimit:", error);
    }
  };

  const calculateWithVAT = async (withoutVAT, vat) => {
    try {
      const baseAmount = Number(withoutVAT || 0);
      const vatTotal = baseAmount * (Number(vat) / Number(100));
      const withVAT = baseAmount + Number(vatTotal);

      if (vat == 0) {
        setAmount0(baseAmount);
        setValueWithVAT0(withVAT);
      } else if (vat == 8) {
        setAmount8(baseAmount);
        setValueWithVAT8(withVAT);
        setVat8(vatTotal);
      } else if (vat == 18) {
        setAmount18(baseAmount);
        setValueWithVAT18(withVAT);
        setVat18(vatTotal);
      }
    } catch (error) {
      console.error("Gabim gjatë kalkulimit:", error);
      // Perform any necessary error handling here
    }
  };

  const calculateFromVAT = async (vatValue, vat) => {
    try {
      const input = Number(vatValue);
      const withoutVAT = input / (Number(vat) / 100);
      const totalAmount = withoutVAT + input;

      if (vat == 0) {
        setValueWithVAT0(totalAmount);
        setAmount0(withoutVAT);
      } else if (vat == 8) {
        setValueWithVAT8(totalAmount);
        setAmount8(withoutVAT);
        setVat8(input);
      } else if (vat == 18) {
        setValueWithVAT18(totalAmount);
        setAmount18(withoutVAT);
        setVat18(input);
      }
    } catch (error) {
      console.error("Gabim gjatë kalkulimit:", error);
    }
  };
  //Pjesa per select input field Clients
  const [field, setField] = useState(null);
  //   const handleAutocompleteChangeSuppliers = (event, value) => {
  //     if (value && value.AccountID) {
  //       setSupplierID(value.AccountID);
  //       setField(value);
  //     } else {
  //       // Në rast se vlera është pastruar
  //       setSupplierID(""); // Vendos vlerën e ArticleID në null
  //     }
  //   };

  //   const defaultPropsSuppliers = {
  //     options: suppliers,
  //     getOptionLabel: (option) =>
  //       `${option.IdentificationNumber} - ${option.AccountName}` || "",
  //     renderOption: (props, option) => (
  //       <>
  //         <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //           <span>
  //             {option.IdentificationNumber}
  //             <br />
  //             {option.AccountName}
  //           </span>
  //         </li>
  //       </>
  //     ),
  //   };

  //E merr unit id nga nje klas tjeter
  useEffect(() => {
    getUnitID(headers).then(setUnID);
  }, [headers]);

  useEffect(() => {
    // fetchSuppliers();
    fetchPaymentType();
    // fetchExpence()
  }, []);

  useEffect(() => {
    if (!isEditMode) {
      setInitialFormSnapshot(createEmptySnapshot());
    }
  }, [isEditMode]);

  useEffect(() => {
    if (isInitializing || isEditMode) {
      return;
    }

    const timerId = window.setTimeout(() => {
      if (invoiceNrInputRef.current) {
        invoiceNrInputRef.current.focus();
      }
    }, 0);

    return () => window.clearTimeout(timerId);
  }, [isInitializing, isEditMode]);

  useEffect(() => {
    if (!invoiceNR || !supplierID) {
      setInvNumberExist(0);
      setInvoiceOtherSupplierMessage("");
      return;
    }

    let isCancelled = false;

    const validateInvoice = async () => {
      try {
        const response = await axios.get(
          ApiLink.API_URL + "PurchaseInTotal/invoice-validation",
          {
            headers,
            params: {
              invNumber: invoiceNR,
              fiscalYear,
              supplierId: Number(supplierID),
              transactionId: isEditMode
                ? Number(editingTransactionId || transactionId || 0)
                : 0,
            },
          },
        );

        if (isCancelled) {
          return;
        }

        const sameSupplierExists = Boolean(response?.data?.sameSupplierExists);
        const existsWithOtherSupplier = Boolean(response?.data?.existsWithOtherSupplier);
        const otherSupplierNames = response?.data?.otherSupplierNames || "";

        setInvNumberExist(sameSupplierExists ? 1 : 0);

        if (!sameSupplierExists && existsWithOtherSupplier) {
          setInvoiceOtherSupplierMessage(
            `Ky numër i faturës ekziston për furnitor tjetër: ${otherSupplierNames}`,
          );
        } else {
          setInvoiceOtherSupplierMessage("");
        }
      } catch (error) {
        if (!isCancelled) {
          setInvNumberExist(0);
          setInvoiceOtherSupplierMessage("");
        }
      }
    };

    validateInvoice();

    return () => {
      isCancelled = true;
    };
  }, [
    invoiceNR,
    supplierID,
    fiscalYear,
    headers,
    isEditMode,
    editingTransactionId,
    transactionId,
  ]);

  const fillFormForEdit = (item) => {
    const safeInvoiceNr = item?.InvoiceNr || "";
    const invoiceDateIso = (item?.Date || "").substring(0, 10);
    const paymentDateIso = (item?.PayDate || item?.Date || "").substring(0, 10);
    const supplierAccountId = item?.SupplierID || item?.AccountID || "";
    const amount0Value = Number(item?.Amount0 || 0);
    const amount8Value = Number(item?.Amount8 || 0);
    const amount18Value = Number(item?.Amount18 || 0);
    const vat8Value = Number(item?.VAT8 || 0);
    const vat18Value = Number(item?.VAT18 || 0);

    setEditingTransactionId(item?.TransactionID || transactionId || "");
    setInvoiceNR(safeInvoiceNr);
    setInitialInvoiceNr(safeInvoiceNr);
    setDate(invoiceDateIso);
    setPayDate(paymentDateIso);
    setSupplierID(String(supplierAccountId || ""));
    setField(
      supplierAccountId
        ? {
            AccountID: supplierAccountId,
            AccountName: item?.AccountName || "",
          }
        : null,
    );
    setPaymentOptions(String(item?.PaymentOptions ?? ""));
    setTransactionType(Number(item?.TransactionType || 1));
    setComent(item?.Coment || "");
    setAmount0(amount0Value);
    setAmount8(amount8Value);
    setAmount18(amount18Value);
    setVat8(vat8Value);
    setVat18(vat18Value);
    setValueWithVAT0(amount0Value);
    setValueWithVAT8(amount8Value + vat8Value);
    setValueWithVAT18(amount18Value + vat18Value);
    setInitialFormSnapshot({
      invoiceNR: safeInvoiceNr,
      date: invoiceDateIso,
      payDate: paymentDateIso,
      supplierID: String(supplierAccountId || ""),
      paymentOptions: String(item?.PaymentOptions ?? ""),
      transactionType: Number(item?.TransactionType || 1),
      coment: item?.Coment || "",
      amount0: round2(amount0Value),
      amount8: round2(amount8Value),
      amount18: round2(amount18Value),
      vat8: round2(vat8Value),
      vat18: round2(vat18Value),
      valueWithVAT0: round2(amount0Value),
      valueWithVAT8: round2(amount8Value + vat8Value),
      valueWithVAT18: round2(amount18Value + vat18Value),
    });
  };

  useEffect(() => {
    let isCancelled = false;

    const initEditMode = async () => {
      if (!isEditMode) {
        setIsInitializing(false);
        return;
      }

      try {
        const response = await axios.get(
          ApiLink.API_URL + `PurchaseInTotal/view-mode/${transactionId}`,
          { headers },
        );

        if (!isCancelled) {
          fillFormForEdit(response.data);
        }
      } catch (error) {
        if (!isCancelled) {
          errorAlert("Gabim në marrjen e të dhënave për editim.");
          history.push("/purchases/purchaseintotal");
        }
      } finally {
        if (!isCancelled) {
          setIsInitializing(false);
        }
      }
    };

    initEditMode();

    return () => {
      isCancelled = true;
    };
  }, [isEditMode, headers, transactionId, history]);

  if (isInitializing) {
    return (
      <div className="pit-form-page" style={{ minHeight: "280px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            minHeight: "280px",
          }}
        >
          <CircularProgress size={28} />
        </div>
      </div>
    );
  }

  return (
    <div className="pit-form-page">
      <div className="pit-form-header">
        <div>
          <h2 className="pit-form-title">
            {isEditMode ? "Ndrysho blerjen në total" : "Blerje e re në total"}
          </h2>
          <p className="pit-form-subtitle">
            {isEditMode
              ? "Përditëso fushat e blerjes dhe ruaj ndryshimet."
              : "Plotëso fushat kryesore dhe ruaj faturën e blerjes."}
          </p>
        </div>
        <div className="pit-form-header-actions">
            {!isEditMode && (
              <button
                type="button"
                className="pit-btn pit-btn-secondary"
                onClick={() => {
                  setDate("");
                  setPayDate("");
                  setInvoiceNR("");
                  setSupplierID("");
                  setComent("");
                  setPaymentOptions("");
                  setAmount0(0);
                  setAmount8(0);
                  setAmount18(0);
                  setTransactionType(1);
                  setValueWithVAT0(0);
                  setValueWithVAT8(0);
                  setValueWithVAT18(0);
                  setVat8(0);
                  setVat18(0);
                  setField(null);
                  setInvNumberExist(undefined);
                  setInvoiceOtherSupplierMessage("");
                  setInitialFormSnapshot(createEmptySnapshot());
                }}
                disabled={insertingTransaction}
              >
                Pastro
              </button>
            )}
            <button
              type="button"
              className="pit-btn pit-btn-ghost"
              onClick={handleCloseClick}
              disabled={insertingTransaction}
            >
              Mbyll
            </button>
            <button
              type="submit"
              form="pit-form"
              className={`pit-btn pit-btn-primary${invNumberExist > 0 ? " invoice-exists" : ""}`}
              disabled={
                insertingTransaction ||
                invNumberExist > 0 ||
                (!isEditMode && isInsertFormEmpty) ||
                (isEditMode && !isFormDirty)
              }
            >
              {insertingTransaction ? (
                <CircularProgress size={18} style={{ color: "#fff" }} />
              ) : invNumberExist > 0 ? (
                "Ky numër i faturës ekziston"
              ) : (
                isEditMode ? "Përditëso" : "Ruaj"
              )}
            </button>
        </div>
      </div>

      <form id="pit-form" className="pit-form-body" onSubmit={handleSubmit} noValidate>
        <div className="pit-top-grid">
          <section className="pit-card pit-card-elevated">
            <div className="pit-card-headline">
              <h3 className="pit-card-title">Informacioni i Përgjithshëm</h3>
              <span className="pit-card-chip">Dokumenti</span>
            </div>
            <div className="pit-form-cluster">
              <p className="pit-cluster-title">Detajet e Dokumentit</p>
              <div className="pit-grid two-columns">
                <div className="pit-grid-full">
                  <TextField
                    label="Numri Fatures"
                    fullWidth
                    required
                    inputRef={invoiceNrInputRef}
                    value={invoiceNR}
                    onChange={(event) => {
                      setInvoiceNR(event.target.value);
                      if (validationErrors.invoiceNR) {
                        setValidationErrors((prev) => ({ ...prev, invoiceNR: "" }));
                      }
                    }}
                    error={invNumberExist > 0 || Boolean(validationErrors.invoiceNR)}
                    helperText={
                      invNumberExist > 0
                        ? "Ky numër i faturës ekziston në listë."
                        : validationErrors.invoiceNR || undefined
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <TextField
                  label="Data Faturës"
                  type="date"
                  value={date}
                  onChange={(e) => {
                    setDate(e.target.value);
                    setPayDate(e.target.value);
                    if (validationErrors.date) {
                      setValidationErrors((prev) => ({ ...prev, date: "" }));
                    }
                    if (validationErrors.payDate) {
                      setValidationErrors((prev) => ({ ...prev, payDate: "" }));
                    }
                  }}
                  required
                  error={Boolean(validationErrors.date)}
                  helperText={validationErrors.date || undefined}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: minDate, max: maxDate }}
                />
                <TextField
                  label="Data pagesës"
                  type="date"
                  value={payDate}
                  onChange={(e) => {
                    setPayDate(e.target.value);
                    if (validationErrors.payDate) {
                      setValidationErrors((prev) => ({ ...prev, payDate: "" }));
                    }
                  }}
                  required
                  error={Boolean(validationErrors.payDate)}
                  helperText={validationErrors.payDate || undefined}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: minDate, max: maxDate }}
                />
                <div className="pit-grid-full">
                  <div style={{ display: "flex", alignItems: "center", gap: 0 }}>
                    <div style={{ flex: 1 }}>
                      {isEditMode ? (
                        <AccountsAutocompleteEdit
                          ledgerID={302}
                          textFieldWidth="100%"
                          accountID={supplierID}
                          label="Kerko Furnitorin"
                          labelId="AccountID"
                          onSelect={(account) => {
                            setSupplierID(account.AccountID);
                            setField(account);
                            if (validationErrors.supplierID) {
                              setValidationErrors((prev) => ({ ...prev, supplierID: "" }));
                            }
                          }}
                          onClear={() => {
                            setSupplierID("");
                            setField(null);
                          }}
                        />
                      ) : (
                        <AccountsAutocompleteInsert
                          ledgerID={302}
                          textFieldWidth="100%"
                          value={field}
                          label="Kerko Furnitorin"
                          labelId="AccountID"
                          disableAutoFocus
                          onSelect={(account) => {
                            setSupplierID(account.AccountID);
                            setField(account);
                            if (validationErrors.supplierID) {
                              setValidationErrors((prev) => ({ ...prev, supplierID: "" }));
                            }
                          }}
                          onClear={() => {
                            setSupplierID("");
                            setField(null);
                          }}
                        />
                      )}
                    </div>
                    <IconButton
                      size="small"
                      onClick={() => setShowSupplierModal(true)}
                      aria-label="Shto furnitor"
                      title="Shto furnitor"
                      sx={{
                        border: "1px solid #c5d8ce",
                        borderRadius: "8px",
                        color: "#2f5649",
                        fontSize: "22px",
                        fontWeight: 700,
                        width: 48,
                        height: 48,
                        minWidth: 48,
                        minHeight: 48,
                        maxWidth: 48,
                        maxHeight: 48,
                        p: 0,
                        lineHeight: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      +
                    </IconButton>
                  </div>
                  {validationErrors.supplierID && (
                    <div
                      style={{
                        marginTop: 6,
                        color: "#d32f2f",
                        fontSize: 12,
                        lineHeight: 1.3,
                      }}
                    >
                      {validationErrors.supplierID}
                    </div>
                  )}
                </div>
                {invoiceOtherSupplierMessage && invNumberExist <= 0 && (
                  <div className="pit-grid-full">
                    <div
                      style={{
                        marginTop: 4,
                        padding: "10px 12px",
                        borderRadius: 8,
                        border: "1px solid #f2c078",
                        background: "#fff8ee",
                        color: "#8b5e1a",
                        fontSize: 12,
                        lineHeight: 1.35,
                      }}
                    >
                      {invoiceOtherSupplierMessage}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>

          <section className="pit-card pit-card-elevated">
            <div className="pit-card-headline">
              <h3 className="pit-card-title">Klasifikimi</h3>
              <span className="pit-card-chip">Kontabiliteti</span>
            </div>
            <div className="pit-form-cluster">
              <p className="pit-cluster-title">Kategorizimi i Blerjes</p>
              <div className="pit-grid two-columns">
                <div className="pit-grid-full">
                  <TextField
                    label="Llogaria Kontabël"
                    value="107-Malli"
                    disabled
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <TextField
                  select
                  label="Lloji Blerjes"
                  value={transactionType}
                  onChange={(event) => setTransactionType(event.target.value)}
                  required
                  SelectProps={{
                    MenuProps: paymentMenuProps,
                    IconComponent: sharedDropdownIcon,
                  }}
                  InputProps={{
                    sx: {
                      borderRadius: 8,
                      height: 48,
                      minHeight: 48,
                      maxHeight: 48,
                      background: "#f5f9f7",
                      borderColor: "#d4e2db",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#4E7B67",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#4E7B67",
                      },
                      "& .MuiSelect-select, & .MuiInputBase-input": {
                        height: 48,
                        minHeight: 48,
                        maxHeight: 48,
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 14px",
                      },
                    },
                  }}
                  FormControlProps={{
                    sx: {
                      borderRadius: 8,
                      height: 48,
                      minHeight: 48,
                      maxHeight: 48,
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                >
                  {TranscationData.map((data) => (
                    <MenuItem key={data.id} value={data.id}>
                      {data.type}
                    </MenuItem>
                  ))}
                </TextField>
                {isEditMode ? (
                  <TextField
                    select
                    label="Mënyra Pagesës"
                    value={paymentOptions}
                    onChange={(event) => {
                      setPaymentOptions(event.target.value);
                      if (validationErrors.paymentOptions) {
                        setValidationErrors((prev) => ({
                          ...prev,
                          paymentOptions: "",
                        }));
                      }
                    }}
                    error={Boolean(validationErrors.paymentOptions)}
                    helperText={validationErrors.paymentOptions || ""}
                    SelectProps={{
                      MenuProps: paymentMenuProps,
                      IconComponent: sharedDropdownIcon,
                    }}
                    InputProps={{
                      sx: {
                        borderRadius: 8,
                        height: 48,
                        minHeight: 48,
                        maxHeight: 48,
                        background: "#f5f9f7",
                        borderColor: "#d4e2db",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#4E7B67",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#4E7B67",
                        },
                        "& .MuiSelect-select, & .MuiInputBase-input": {
                          height: 48,
                          minHeight: 48,
                          maxHeight: 48,
                          boxSizing: "border-box",
                          display: "flex",
                          alignItems: "center",
                          padding: "0 14px",
                        },
                      },
                    }}
                    FormControlProps={{
                      sx: {
                        borderRadius: 8,
                        height: 48,
                        minHeight: 48,
                        maxHeight: 48,
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem key="0" value="0">
                      Pagesa Behet më vonë
                    </MenuItem>
                    {cashRegister.map((data) => (
                      <MenuItem key={data.AccountID} value={String(data.AccountID)}>
                        {data.AccountName}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : (
                  <PaymentTypeSelect
                    value={paymentOptions}
                    onChange={(event) => {
                      setPaymentOptions(event.target.value);
                      if (validationErrors.paymentOptions) {
                        setValidationErrors((prev) => ({
                          ...prev,
                          paymentOptions: "",
                        }));
                      }
                    }}
                    error={Boolean(validationErrors.paymentOptions)}
                    helperText={validationErrors.paymentOptions || ""}
                    sx={{ borderRadius: 8 }}
                  />
                )}
                <div className="pit-grid-full">
                  <TextField
                    className="pit-comment"
                    label="Komenti"
                    multiline
                    rows={1}
                    value={coment}
                    onChange={(event) => setComent(event.target.value)}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </section>
        </div>

        <section className="pit-card">
          <h3 className="pit-card-title">Vlerat dhe TVSH</h3>
          <div className="pit-vat-table">
            <div className="pit-vat-head">
              <div>Norma TVSH</div>
              <div>Vlera pa TVSH</div>
              <div>Vlera e TVSH</div>
              <div>Total</div>
            </div>

            {isVatDeclarant && (
              <>
                <div className="pit-vat-row">
                  <div className="pit-vat-rate">18%</div>
                  <PriceField
                    label=""
                    name="amount18"
                    value={amount18}
                    onChange={(event) => calculateWithVAT(event.target.value, 18)}
                  />
                  <PriceField
                    label=""
                    name="vat18"
                    value={vat18}
                    onChange={(event) => calculateFromVAT(event.target.value, 18)}
                  />
                  <PriceField
                    label=""
                    name="total18"
                    value={valueWithVAT18}
                    decimalScale={2}
                    onChange={(event) => calculateWithoutVAT(event.target.value, 18)}
                  />
                </div>

                <div className="pit-vat-row">
                  <div className="pit-vat-rate">8%</div>
                  <PriceField
                    label=""
                    name="amount8"
                    value={amount8}
                    onChange={(event) => calculateWithVAT(event.target.value, 8)}
                  />
                  <PriceField
                    label=""
                    name="vat8"
                    value={vat8}
                    onChange={(event) => calculateFromVAT(event.target.value, 8)}
                  />
                  <PriceField
                    label=""
                    name="total8"
                    value={valueWithVAT8}
                    decimalScale={2}
                    onChange={(event) => calculateWithoutVAT(event.target.value, 8)}
                  />
                </div>
              </>
            )}

            <div className="pit-vat-row">
              <div className="pit-vat-rate">0%</div>
              <PriceField
                label=""
                name="amount0"
                value={amount0}
                onChange={(event) => calculateWithVAT(event.target.value, 0)}
              />
              <PriceField label="" name="vat0" value={0} disabled />
              <PriceField
                label=""
                name="total0"
                value={valueWithVAT0}
                decimalScale={2}
                onChange={(event) => calculateWithoutVAT(event.target.value, 0)}
              />
            </div>
          </div>

          <div className="pit-vat-totals-row">
            <div className="pit-vat-totals-label">Totale</div>
            <div className="pit-vat-total-item">
              <span>Total pa TVSH</span>
              <strong>{formatEuroValue(Number(amount0) + Number(amount8) + Number(amount18))} €</strong>
            </div>
            <div className="pit-vat-total-item">
              <span>Total TVSH</span>
              <strong>{formatEuroValue(Number(vat8) + Number(vat18))} €</strong>
            </div>
            <div className="pit-vat-total-item grand-total">
              <span>Total me TVSH</span>
              <strong>
                {formatEuroValue(
                  Number(amount0) +
                    Number(amount8) +
                    Number(amount18) +
                    Number(vat8) +
                    Number(vat18),
                )}{" "}
                €
              </strong>
            </div>
          </div>
        </section>
      </form>

      <SuppliersModal
        show={showSupplierModal}
        onHide={() => setShowSupplierModal(false)}
        mode="insert"
        type="none"
      />

      <Dialog
        open={showCloseConfirm}
        onClose={() => setShowCloseConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Konfirmo mbylljen</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ke ndryshime të paruajtura. Nëse mbyll këtë formë, të dhënat e
            pa-ruajtura do të humbin. A je i sigurt që dëshiron të vazhdosh?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setShowCloseConfirm(false)} color="inherit">
            Anulo
          </Button>
          <Button
            onClick={() => {
              setShowCloseConfirm(false);
              closePage();
            }}
            variant="contained"
            sx={{ backgroundColor: "#2f5649", "&:hover": { backgroundColor: "#284945" } }}
          >
            Po, mbylle
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default PurchaseInTotalForm;
